import React from 'react';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import ValidationElement from '../ValidationElement';
import Generic from '../Generic';
import SvgComponent from '../SvgComponent';

export default class Text extends ValidationElement {
  constructor(props) {
    super(props);

    this.state = {
      value: props.prefilter(props.value),
    };
    this.update = this.update.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);

    this.text = React.createRef();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.value, nextProps.value)) {
      if (this.state.value === nextProps.value) {
        return;
      }
      this.setState({ value: this.props.prefilter(nextProps.value) });
    }
  }

  handleBlur(event) {
    this.update({
      value: this.props.useFilter ? this.onBlurFilter(this.state.value) : this.state.value,
      name: this.props.name,
    });
    super.handleBlur(event);
  }

  /**
  *  Apply filter on blur to clean up unnecessary text such as leading and trailing whitespace
  */
  onBlurFilter(value) {
    return value.trim();
  }

  /**
   * Handle the change event.
   */
  handleChange(event) {
    const value = this.props.prefilter(event.target.value);
    const filterOccurred = value !== event.target.value;
    let clonedEvent = filterOccurred ? cloneDeep(event) : event;

    // need to update the value on the cloned event, so that we are not
    if (filterOccurred) {
      clonedEvent.target.value = value;
    }

    if (clonedEvent.target?.name === 'zipcode' && clonedEvent.target.value.length > 5) {
      // if not already cloned, we need to clone so that we are not mutating the event
      if (!filterOccurred) {
        clonedEvent = cloneDeep(clonedEvent);
      }

      // add dash for 9 didgit zips
      const regex = /(\d{5})(\d{4})/;
      clonedEvent.target.value = clonedEvent.target.value.replace(regex, '$1-$2'); // eslint-disable-line no-param-reassign
    } else if (filterOccurred) {
      clonedEvent.target.value = value;
    }

    this.setState({ value: clonedEvent.target.value }, () => {
      super.handleChange(clonedEvent);
    });
  }

  handleError(value, arr) {
    let arr2 = [...(arr || [])];
    if (this.props.prefix) {
      arr2 = arr2.map((err) => ({
        code: `${this.props.prefix}.${err.code}`,
        valid: err.valid,
        uid: err.uid,
      }));
    }

    // Take the original and concatenate our new error values to it
    return this.props.onError(value, arr2);
  }

  update(queue) {
    this.props.onUpdate({
      ...queue,
    });
  }

  shouldDisplayCurrency() {
    return this.props.currency && this.state.value && !this.state.value.match(/\D/);
  }

  displayCurrency() {
    // Probably deprecated due to Currency component, consider removal
    return (
      <span className="currency">
        <div className="dollar-sign">
          <SvgComponent className="dollar-sign" src="/img/dollar-sign.svg" />
        </div>
        {this.displayGeneric()}
      </span>
    );
  }

  displayGeneric() {
    return (
      <Generic
        attribute={this.props.attribute}
        name={this.props.name}
        ariaLabel={this.props.ariaLabel}
        label={this.props.label}
        placeholder={this.props.placeholder}
        type={this.props.hideText ? 'password' : 'text'}
        className={this.props.className}
        disabled={this.props.disabled}
        status={this.props.status}
        minlength={this.props.minlength}
        maxlength={this.props.maxlength}
        pattern={this.props.pattern}
        inputFilter={this.props.inputFilter}
        readonly={this.props.readonly}
        required={this.props.required}
        value={this.state.value}
        focus={this.props.focus}
        onChange={this.handleChange} // eslint-disable-line @typescript-eslint/unbound-method
        onFocus={this.props.onFocus}
        onBlur={this.handleBlur} // eslint-disable-line @typescript-eslint/unbound-method
        onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
        onKeyDown={this.props.onKeyDown}
        onCopy={this.props.onCopy}
        onCut={this.props.onCut}
        onPaste={this.props.onPaste}
        clipboard={this.props.clipboard}
        tabBack={this.props.tabBack}
        tabNext={this.props.tabNext}
        ref={this.text}
        autocorrect={this.props.autocorrect}
        autocapitalize={this.props.autocapitalize}
        spellcheck={this.props.spellcheck}
        additionalLengthErrors={this.props.additionalLengthErrors || false}
        setToUpperCaseOnBlur={this.props.setToUpperCaseOnBlur}
        forceValidation={this.props.forceValidation}
        makeStateFromErrors={this.props.makeStateFromErrors}
      />
    );
  }

  render() {
    return this.shouldDisplayCurrency() ? this.displayCurrency() : this.displayGeneric();
  }
}

Text.defaultProps = {
  name: 'text',
  value: '',
  prefix: '',
  useFilter: true,
  required: false,
  status: true,
  inputFilter: {},
  forceValidation: false,
  makeStateFromErrors: undefined,
  prefilter: (value) => value,
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
};

Text.errors = [];
